export { PersistentStorageStrategyFactory } from './factories';
export { sessionStorage } from './sessionStorageSingleton';
export { storage } from './storageSingleton';
export { cookieStorageStrategy, localStorageStrategy, noOpStrategy, sessionStorageStrategy, } from './strategies';
